import React from 'react';
import { Robot, Twilio } from '~/ui/assets/icons';
import LogoSmall from '~/ui/assets/imgs/logoSmall.svg';

type TicketCreationOriginKey =
  | 'BOT'
  | 'BOT_CONCIERGE'
  | 'BOT_CONCIERGE_V2'
  | 'BACKOFFICE'
  | 'BACKOFFICE_AUTOMATIC'
  | 'TWILIO_MANUAL'
  | 'TWILIO_AUTOMATIC'
  | 'APP';

type OriginVisualConfig = {
  label: string;
  icon: React.ReactNode;
};

export const ticketCreationOriginOptions = [
  { value: 'BACKOFFICE', label: 'Backoffice' },
  { value: 'BACKOFFICE_AUTOMATIC', label: 'Backoffice automático' },
  { value: 'BOT', label: 'GPT' },
  { value: 'BOT_CONCIERGE', label: 'GPT Concierge' },
  { value: 'BOT_CONCIERGE_V2', label: 'Concierge V2' },
  { value: 'APP', label: 'APP' },
  { value: 'TWILIO_MANUAL', label: 'Twilio Manual' },
  { value: 'TWILIO_AUTOMATIC', label: 'Twilio automático' },
];

export function getTicketCreationOriginVisual(creationOrigin: string, colors: any): OriginVisualConfig | null {
  const openedBy: Record<TicketCreationOriginKey, OriginVisualConfig> = {
    BOT: {
      label: 'Aberto pelo GPT',
      icon: <Robot />,
    },
    BOT_CONCIERGE: {
      label: 'Aberto pelo GPT Concierge',
      icon: <Robot />,
    },
    BOT_CONCIERGE_V2: {
      label: 'Aberto pelo Concierge V2',
      icon: <Robot />,
    },
    APP: {
      label: 'Aberto pelo APP',
      icon: <LogoSmall color={colors.element.primary} />,
    },
    BACKOFFICE: {
      label: 'Aberto pelo backoffice',
      icon: <LogoSmall color={colors.element.primary} />,
    },
    BACKOFFICE_AUTOMATIC: {
      label: 'Aberto pelo backoffice automático',
      icon: <LogoSmall color={colors.element.primary} />,
    },
    TWILIO_MANUAL: {
      label: 'Aberto pelo twilio manual',
      icon: <Twilio color={colors.negative.primaryAlt} />,
    },
    TWILIO_AUTOMATIC: {
      label: 'Aberto pelo twilio automático',
      icon: <Twilio color={colors.negative.primaryAlt} />,
    },
  };

  return openedBy?.[creationOrigin as TicketCreationOriginKey] || null;
}
